<template>
  <div class="resume-content" v-if="projectInfos.length>0">
    <div class="resume-view-section-header">PROJECT</div>
    
    <div v-if="!noData">
      <div v-bind:key="index" v-for="(projectItem, index) in projectInfos">
        <experience-card :index="index" :edu="projectItem"></experience-card>
      </div>
    </div>
     
    <div style="margin-top: 1rem" v-if="noData">
      <div style="color: #ff5252">
        Seems like you haven't added your project information yet!
      </div>
    </div>
  </div>
</template>

<script>
import ExperienceCard from "./project-cards";
import { GET_CANDIDATE_PROJECTS } from "../../../Api/candidate_api";
import {SORT_PROFILE} from "../../../filters";
export default {
  name: "project-view",
  components: {
    ExperienceCard
  },
  props:{
    project:Array
  },
  data: function() {
    return {
      projectInfos: [],
      noData: false
    };
  },
  methods: {
    // getUserEducationalInfo: function() {
    //   const self = this;
    //   GET_CANDIDATE_PROJECTS()
    //     .then(function(response) {
    //       self.eduInfos = SORT_PROFILE(response, "is_working");
    //       self.noData = self.eduInfos.length === 0;
    //     })
    //     .catch(function() {
    //       self.noData = true;
    //     });
    // }
  },
  mounted: function() {
    // this.getUserEducationalInfo();
    if(this.project)this.projectInfos=this.project
  }
};
</script>

<style scoped>
.experience-content {
  margin-top: 2rem;
}
.header-text {
  text-align: left;
  background-color: #f7f7f7;
  padding: 0.5rem 1rem;
  color: #050505;
}
</style>
